import { render, staticRenderFns } from "./auth-select.vue?vue&type=template&id=1ccbd156&scoped=true"
import script from "./auth-select.vue?vue&type=script&lang=js"
export * from "./auth-select.vue?vue&type=script&lang=js"
import style0 from "./auth-select.vue?vue&type=style&index=0&id=1ccbd156&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccbd156",
  null
  
)

export default component.exports